// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bPN5","importantInfo":"styles_importantInfo__3C7Je"};